import {Link} from "react-router-dom";

export default () => {
    return (
        <ul>
            <li><Link to="/reference-information-hotels">Гостиницы, мотели, кемпинги Hotels, Motels, Campings</Link></li>
            <li><Link to="/reference-information-bars">Рестораны, бары Restaurants, bars</Link></li>
            <li><Link to="/reference-information-sanatoriums">Санатории, турбазы, зоны отыха Sanatorium, camp site</Link></li>
            <li><Link to="/reference-information-museums">Музеи и выставочные залы Museums and Show-rooms</Link></li>
            <li><Link to="/reference-information-agriculturalmanors">Сельские усадьбы Agricultural manors</Link></li>
            <li><Link to="/reference-information-operators">Туроператоры, турагентства Tour Operators, Travel Agencies</Link></li>
            <li><Link to="/reference-information-consulates">Консульства Consulates</Link></li>
        </ul>
    );
}